import React from 'react';
import { Action, SwedishFrejaID_CancelMessageModel, ViewVersion } from '../renditions';
import Frame from '../components/Frame';
import Footer from '../components/Footer';

import './styling';
import { Language } from 'criipto-verify-react-4';
import { LocalizedTexts } from '../components/Language';
import ActionHeader from '../components/ActionHeader';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

export default function Cancel(props: {
  model: SwedishFrejaID_CancelMessageModel,
  action: Action,
  version: ViewVersion
}) {
  const {model, action} = props;

  return (
    <React.Fragment>
      <Frame className="centered" id="sefrejaid_cancel_frame">
        <div id="sefrejaid_cancel_content">
          <div id="sefrejaid_cancel_icon">
            <FontAwesomeIcon icon={faCircleXmark} />
          </div>
          <div id="sefrejaid_cancel_texts">
            <div id="sefrejaid_cancel_message">
              <LocalizedTexts
                texts={
                  [
                    {language: 'en', text: `You declined the login in the Freja app.`},
                    {language: 'sv', text: `Du avbröt inloggningen i Freja-appen.`}
                  ]
                }
              />
            </div>
          </div>
        </div>
      </Frame>
      <Footer language={model.language as Language} />
    </React.Fragment>
  );
}
